import React from "react";

export default function QuantitySelector({ val, onDec, onInc }) {
  return (
    <div className="d-inline-flex justify-content-center my-2 align-items-center mx-2">
      <button className="btn btn-light p-0 m-0 fs-5 lh-1" onClick={onDec}>
        <i className="bi bi-dash-circle"></i>
      </button>
      <span className="p-0 m-0 mx-2 fs-6 lh-1">{val}</span>
      <button className="btn p-0 m-0 fs-5 lh-1" onClick={onInc}>
        <i className="bi bi-plus-circle"></i>
      </button>
    </div>
  );
}
